// extracted by mini-css-extract-plugin
module.exports = {"rankingCard":"RankingCard_rankingCard__3ySAj"};